import { message, Spin } from 'antd';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { updateUser, useGetUser } from '../../api/users';
import UserForm from '../../shared/components/forms/user/Form';

const UserUpdatePage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useGetUser(Number(id));

  const { mutateAsync: updateMutate } = useMutation(updateUser, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['users', 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [`users/${id}`, undefined],
      });
      message.info('Update user successfully!');
      navigate(`/users`, { replace: true });
    },
    onError: () => {
      message.error('Update user failed! Please try again');
    },
  });

  const handleSubmit = async (values: any) => {
    updateMutate({ ...values, id });
  };

  return (
    <Spin spinning={isLoading}>
      <div className="users-container">
        <div className="page-container">
          <div className="page-content">
            <div className="page-content-header">
              <h2 className="title-page">Edit User</h2>
            </div>
            <UserForm handleSubmit={handleSubmit} user={data} userId={Number(id)} />
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default UserUpdatePage;
